/**
 * @typedef {"boot"|"intro"|"about"|"projects"|"projectDetail"|"skills"|"contact"|"legal"|"transitioning"} SceneState
 */

export const SCENE_STATES = {
  BOOT: "boot",
  INTRO: "intro",
  ABOUT: "about",
  PROJECTS: "projects",
  PROJECT_DETAIL: "projectDetail",
  SKILLS: "skills",
  CONTACT: "contact",
  LEGAL: "legal",
  TRANSITIONING: "transitioning"
};

export const SCROLL_STATES = [
  SCENE_STATES.INTRO,
  SCENE_STATES.ABOUT,
  SCENE_STATES.PROJECTS,
  SCENE_STATES.SKILLS,
  SCENE_STATES.CONTACT
];
